export default __webpack_public_path__ + "static/media/spider-web-background.207c3fc6.png";